import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, Form } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { MaShipcaseService } from '../../../service/mashipcase/mashipcase.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9215',
  templateUrl: 'wa9215.component.html',
  styleUrls: ['wa9215.component.scss']
})
export class Wa9215Component implements OnInit {
  public componentTitle = 'WA9215:出荷ケースマスタ登録';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId: FormControl;
  public maShipcaseId: number;
  public shipcaseCd: FormControl;
  public shipcaseTx: FormControl;
  public lengthNr: FormControl;
  public widthNr: FormControl;
  public heightNr: FormControl;
  public capacityrateNr: FormControl;
  public selectedOwnerId: number ;
  public ownerResult;

  public owners: any

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Input() selectedownerId;
  @Input() selectedOwnerTx;
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private ownerIdCls = '';
  private shipcaseCdCls = '';
  private shipcaseTxCls = '';
  private lengthNrCls = '';
  private widthNrCls = '';
  private heightNrCls = '';
  private capacityrateNrCls = ''

  constructor(
    private ownerService: OwnerService,
    private maShipcaseService: MaShipcaseService,
    private commonService: CommonService,
  ) {
    this.ownerId = new FormControl('', [
      Validators.required,
    ]),
    this.shipcaseCd = new FormControl('', [
      Validators.pattern(validation.allBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.shipcaseCd.maxLength)
    ]);
    this.shipcaseTx = new FormControl('', [
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.shipcaseTx.maxLength)]);
    this.lengthNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.shipcaseLengthNr.maxNr),
      Validators.min(validation.shipcaseLengthNr.minNr)]);
    this.widthNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.shipcaseWidthNr.maxNr),
      Validators.min(validation.shipcaseWidthNr.minNr)]);
    this.heightNr = new FormControl(0, [
      Validators.required,
      Validators.pattern(validation.decimal_3),
      Validators.max(validation.shipcaseHeightNr.maxNr),
      Validators.min(validation.shipcaseHeightNr.minNr)]);
    this.capacityrateNr = new FormControl(100, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.max(validation.shipcaseCapacityRateNr.maxNr),
      Validators.min(validation.shipcaseCapacityRateNr.minNr)]);


    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        try {
          this.selectedOwnerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
          if (JSON.parse(sessionStorage.getItem('ownerResult')).ownerId !== undefined) {

            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === JSON.parse(sessionStorage.getItem('ownerResult')).ownerId) return true;
            });
            this.selectedownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
            this.ownerId.setValue(JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx);
            this.ownerResult = sessionStorage.getItem('ownerResult');

          } else {
            this.owners = outputJson.owners;
            this.selectedownerId = null;
            this.ownerResult = sessionStorage.getItem('ownerResult');

            this.ownerId.setValue('');

          }
        } catch (error) {
          this.selectedownerId = null;
        }
      })
    }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    let shipcaseCd = this.shipcaseCd.value.trim();
    let shipcaseTx = this.shipcaseTx.value.trim();
    let capacityrateNr = this.capacityrateNr.value / 100;
    
    let errors = false;
    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shipcaseCd.errors !== null) {
      this.shipcaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shipcaseTx.errors !== null) {
      this.shipcaseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.lengthNr.errors !== null) {
      this.lengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.widthNr.errors !== null) {
      this.widthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.heightNr.errors !== null) {
      this.heightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.capacityrateNr.errors !== null) {
      this.capacityrateNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    if (this.working) return;
    this.working = true;

    let ownerIdValue = this.selectedOwnerId ? this.selectedOwnerId : this.ownerId.value;
    
    this.maShipcaseService
      .post(
        ownerIdValue,
        shipcaseCd,
        shipcaseTx, 
        this.lengthNr.value,
        this.widthNr.value,
        this.heightNr.value,
        capacityrateNr,
        'wa9215')
      .then(outputJson => {
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '登録が完了しました');
        }
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    if (this.selectedOwnerId != null) {
        this.selectedOwnerId = null;
    }

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
      let selectedOwnerTx;
      this.ownerService
        .get()
        .then(outputJson => {
          if (this.selectedownerId) {
            this.owners = outputJson.owners.filter((item, index) => {
              if (item.ownerId === this.selectedownerId) {
                this.selectedOwnerId = item.ownerId;
                selectedOwnerTx = item.ownerTx;
                return true;
              }
            });
            this.ownerId.setValue(selectedOwnerTx);
          } else {
            this.owners = outputJson.owners;
            this.ownerId.setValue('');
          }
        })
        .catch(error => {
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.ownerId.setValue('');
    this.shipcaseCd.setValue('');
    this.shipcaseTx.setValue('');
    this.lengthNr.setValue(0);
    this.widthNr.setValue(0);
    this.heightNr.setValue(0);
    this.capacityrateNr.setValue(100);
    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    if ((this.lengthNr.value + '').length == 0)
      this.lengthNr.setValue(0);
    if ((this.widthNr.value + '').length == 0)
      this.widthNr.setValue(0);
    if ((this.heightNr.value + '').length == 0)
      this.heightNr.setValue(0);
    if ((this.capacityrateNr.value + '').length == 0) 
      this.capacityrateNr.setValue(100);
    
    this.ownerIdCls = this.ownerId.disabled ? 'disabled' : this.ownerId.value === '' ? '' : this.STRINGS_ACTIVE;
    this.shipcaseCdCls = this.shipcaseCd.value === '' ? '' : (this.shipcaseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.shipcaseTxCls = this.shipcaseTx.value === '' ? '' : (this.shipcaseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.lengthNrCls = this.lengthNr.value + '' === '0' ? '' : (this.lengthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.widthNrCls = this.widthNr.value + '' === '0' ? '' : (this.widthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.heightNrCls = this.heightNr.value + '' === '0' ? '' : (this.heightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.capacityrateNrCls = this.capacityrateNr.value + '' === '100' ? '' : (this.capacityrateNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
    this.ownerIdCls === this.STRINGS_ACTIVE &&
    this.shipcaseCdCls === this.STRINGS_ACTIVE &&
    this.shipcaseTxCls === this.STRINGS_ACTIVE
    // this.lengthNrCls === this.STRINGS_ACTIVE &&
    // this.widthNrCls === this.STRINGS_ACTIVE &&
    // this.heightNrCls === this.STRINGS_ACTIVE &&
    // this.capacityrateNrCls === this.STRINGS_ACTIVE;
  }

  clrErr() {
    this.errorInfo = '';
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9215/wa9215.component.ts